import types from './types';

const searchVehiclesSuccess = (vehiclesPagedResult, vehiclesFilter) => ({
  type: types.SEARCH_VEHICLES_SUCCESS,
  payload: {
    vehiclesPagedResult,
    vehiclesFilter,
  },
});

const loadVehiclePhotoSeriesSuccess = (vehiclePhotoSeriesPagedResult, vehicleId) => ({
  type: types.LOAD_VEHICLE_PHOTOSERIES_SUCCESS,
  payload: {
    vehiclePhotoSeriesPagedResult,
    vehicleId,
  },
});

const setPagedResultLoaded = (loaded) => ({
  type: types.SET_PAGED_RESULT_LOADED,
  payload: {
    loaded,
  },
});

const loadExportedVehiclesSuccess = (exportedVehicles) => ({
  type: types.LOAD_EXPORTED_VEHICLES_SUCCESS,
  payload: {
    exportedVehicles,
  },
});

const addVehicleExportSuccess = (vehicleExport) => ({
  type: types.ADD_VEHICLE_EXPORT_SUCCESS,
  payload: {
    vehicleExport,
  },
});

export default {
  searchVehiclesSuccess,
  loadVehiclePhotoSeriesSuccess,
  setPagedResultLoaded,
  loadExportedVehiclesSuccess,
  addVehicleExportSuccess,
};
